import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import AppBadge from 'components/App/AppBadge';

// The ledger of refund commands Bookese sent to OnePay (onepay-refund.md §3.2-3.5), shared
// across products. Purely presentational: every cell arrives pre-formatted from the caller (the
// action label, the amount, the status label/color, the result text), so this component carries
// no product vocabulary of its own — a manual refund on the OnePay portal is not in this list,
// that stays the action's own gatewayRef field.
function RefundLedger({ rows }) {
  return (
    <div className="table-responsive">
      <Table size="sm">
        <thead>
          <tr>
            <th>Thời gian</th>
            <th>Hành động</th>
            <th>Số tiền</th>
            <th>Trạng thái</th>
            <th>Kết quả</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id}>
              <td>{row.time}</td>
              <td>{row.action}</td>
              <td>{row.amount}</td>
              <td><AppBadge color={row.status.color}>{row.status.label}</AppBadge></td>
              <td>{row.result}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

RefundLedger.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
    amount: PropTypes.string.isRequired,
    status: PropTypes.shape({
      label: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
    }).isRequired,
    result: PropTypes.string.isRequired,
  })).isRequired,
};

export default memo(RefundLedger);
